module.exports = __webpack_public_path__ + "img/pumping-activities-role.c7f9ad5e.png";